import React, { useEffect, useState } from 'react'
import {List, Space,} from 'antd'
import SoftCourseDesc from './SoftCourseDesc';
import {BulbOutlined,} from '@ant-design/icons';
import { useBnsJiaoChengListQuery } from '../store/ReactWebSiteApi';
function SoftCourseList(props) {
    const [list, setList] = useState([]);      
    const {data, isSuccess} = useBnsJiaoChengListQuery({
        bjc_e_id:'218',
        bjc_bgn_id:props.bjc_bgn_id,
    },{
        refetchOnMountOrArgChange:1,
        skip:!props.bjc_bgn_id,
    });    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bjc_id:key,bjc_name,bjc_ctime,bjc_cname,bjc_content,bjc_dept_id,bjc_dept_name,bjc_bg_name,bjc_bgn_name,keshi} = item;
                    return item = {key,bjc_name,bjc_ctime,bjc_cname,bjc_content,bjc_dept_id,bjc_dept_name,bjc_bg_name,bjc_bgn_name,keshi}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bjc_ctime;
                    let bTimeString = b.bjc_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList([])
            }
            
        }
    }, [data, isSuccess])
    return (
        <div style={{padding:"10px 30px"}}>
           {list.map((item) => {
                console.log(item);
                let arr = []
                if(item.keshi){
                    arr = item.keshi.map((item) => {
                        return <SoftCourseDesc
                            key={item.bjcks_id}
                            bjcks_id={item.bjcks_id}
                            bjcks_name={item.bjcks_name}
                            bjcks_content={item.bjcks_content}
                        />
                    })
                }else{
                    arr='123'
                }
                return <div key={item.key}>
                        <Space><BulbOutlined /> {item.bjc_name}</Space>
                        <List>
                            {arr}
                        </List>
                    </div>
            })}
        </div>
    )
}

export default SoftCourseList